import type { ContentRuntimeState, DeviceSession } from "@teamtable/api";
import { MAX_REPORTED_BUNDLE_URL_LENGTH } from "@teamtable/api";

/** Optional URL telemetry must not prevent context refresh or analytics delivery. */
export function prepareRuntimeState(state: ContentRuntimeState): ContentRuntimeState {
  const report = { ...state };
  if (report.bundle_url && report.bundle_url.length > MAX_REPORTED_BUNDLE_URL_LENGTH) {
    delete report.bundle_url;
  }
  return report;
}

/** Missing extension fields identify a legacy API; explicit null removes assignment. */
export function mergeDeviceSession(current: DeviceSession, next: DeviceSession): DeviceSession {
  return {
    ...next,
    game_context: next.game_context === undefined ? current.game_context : next.game_context,
    context_revision: next.context_revision ?? current.context_revision,
    diagnostics: next.diagnostics ?? current.diagnostics,
  };
}
